import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.actuator');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    standalone: false,
    selector: 'wiz-page-actuator',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.actuator/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageActuatorComponent implements OnInit {
    public activeTab: string = 'motors';
    public searchText: string = '';

    public motors: any[] = [];
    public reducers: any[] = [];
    public spindles: any[] = [];
    public loadedTabs: any = { motors: false, reducers: false, spindles: false };

    public filteredMotors: any[] = [];
    public filteredReducers: any[] = [];
    public filteredSpindles: any[] = [];

    // CRUD modal
    public showModal: boolean = false;
    public modalMode: string = 'create'; // 'create' | 'edit'
    public editItem: any = {};

    // Field definitions per tab
    public motorFields = [
        { key: 'model', label: '모델명', type: 'text' },
        { key: 'type', label: '타입', type: 'select', options: ['BLDC', 'DC', 'Servo', 'Step'] },
        { key: 'rated_power', label: '정격출력 (W)', type: 'number' },
        { key: 'rated_voltage', label: '정격전압 (V)', type: 'number' },
        { key: 'rated_torque', label: '정격토크 (Nm)', type: 'number' },
        { key: 'rated_speed', label: '정격속도 (RPM)', type: 'number' },
        { key: 'max_efficiency', label: '최대효율 (%)', type: 'number' },
    ];
    public reducerFields = [
        { key: 'model', label: '모델명', type: 'text' },
        { key: 'type', label: '타입', type: 'select', options: ['행성', '웜', '하모닉', '사이클로이드'] },
        { key: 'ratio', label: '감속비', type: 'number' },
        { key: 'rated_torque', label: '정격토크 (Nm)', type: 'number' },
        { key: 'max_speed', label: '최대속도 (RPM)', type: 'number' },
        { key: 'efficiency', label: '효율 (%)', type: 'number' },
    ];
    public spindleFields = [
        { key: 'model', label: '모델명', type: 'text' },
        { key: 'type', label: '타입', type: 'select', options: ['볼스크류', '사다리꼴', '리니어'] },
        { key: 'lead', label: '리드 (mm)', type: 'number' },
        { key: 'diameter', label: '직경 (mm)', type: 'number' },
        { key: 'stroke', label: '스트로크 (mm)', type: 'number' },
        { key: 'max_load', label: '최대부하 (kN)', type: 'number' },
        { key: 'effective_length', label: '유효길이 (mm)', type: 'number' },
    ];

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.loadAll();
    }

    public get currentFields() {
        if (this.activeTab === 'motors') return this.motorFields;
        if (this.activeTab === 'reducers') return this.reducerFields;
        return this.spindleFields;
    }

    private assignItems(tab: string, data: any[]) {
        if (tab === 'motors') this.motors = data || [];
        if (tab === 'reducers') this.reducers = data || [];
        if (tab === 'spindles') this.spindles = data || [];
        this.loadedTabs[tab] = true;
    }

    public async loadAll() {
        const tabs = ['motors', 'reducers', 'spindles'];
        const responses = await Promise.all(tabs.map(async tab => {
            try {
                return await wiz.call("list", { tab });
            } catch (error) {
                console.error(`[actuator/list/${tab}]`, error);
                return { code: -1, data: [] };
            }
        }));
        responses.forEach((response: any, index: number) => {
            if (response && response.code === 200) this.assignItems(tabs[index], response.data);
        });
        this.applyFilter();
        await this.service.render();
    }

    public async load() {
        const tab = this.activeTab;
        const { code, data } = await wiz.call("list", { tab });
        if (code === 200) {
            this.assignItems(tab, data);
            this.applyFilter();
        }
        await this.service.render();
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        this.searchText = '';
        if (this.loadedTabs[tab]) {
            this.applyFilter();
            await this.service.render();
        } else {
            await this.load();
        }
    }

    public applyFilter() {
        const q = this.searchText.toLowerCase().trim();
        if (this.activeTab === 'motors') {
            this.filteredMotors = q
                ? this.motors.filter(m => m.model.toLowerCase().includes(q) || m.type.toLowerCase().includes(q))
                : [...this.motors];
        } else if (this.activeTab === 'reducers') {
            this.filteredReducers = q
                ? this.reducers.filter(r => r.model.toLowerCase().includes(q) || r.type.toLowerCase().includes(q))
                : [...this.reducers];
        } else if (this.activeTab === 'spindles') {
            this.filteredSpindles = q
                ? this.spindles.filter(s => s.model.toLowerCase().includes(q) || s.type.toLowerCase().includes(q))
                : [...this.spindles];
        }
    }

    public async onSearch() {
        this.applyFilter();
        await this.service.render();
    }

    public openCreate() {
        this.modalMode = 'create';
        this.editItem = {};
        for (const f of this.currentFields) {
            this.editItem[f.key] = f.type === 'number' ? 0 : '';
        }
        this.showModal = true;
    }

    public openEdit(item: any) {
        this.modalMode = 'edit';
        this.editItem = { ...item };
        this.showModal = true;
    }

    public closeModal() {
        this.showModal = false;
    }

    public async saveItem() {
        if (this.modalMode === 'create') {
            await wiz.call("create", { tab: this.activeTab, data: JSON.stringify(this.editItem) });
        } else {
            await wiz.call("update", { tab: this.activeTab, id: this.editItem.id, data: JSON.stringify(this.editItem) });
        }
        this.showModal = false;
        await this.load();
    }

    public async deleteItem(item: any) {
        const ok = await this.service.modal.show({
            title: '삭제 확인',
            message: `${item.model} 항목을 삭제하시겠습니까?`,
            action: '삭제',
            status: 'error'
        });
        if (ok) {
            await wiz.call("delete", { tab: this.activeTab, id: item.id });
            await this.load();
        }
    }
}

export default PageActuatorComponent;